/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
// RelatorioPDF.js
import React from 'react';
import { Page, Text, View, Document, Image } from '@react-pdf/renderer';
import styles from './styled';
import logo from '../../assets/img/frota_maxima.png';
import NumberFormat from '../../utils/NumberFormat';

function RelatorioPDF({ data, year }) {
  const currentDate = new Date();
  const formattedDate = `${currentDate
    .getDate()
    .toString()
    .padStart(2, '0')}/${(currentDate.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${currentDate.getFullYear()}`;

  // Mapeamento de meses em inglês para português
  const mesesMap = {
    Jan: 'Jan',
    Feb: 'Fev',
    Mar: 'Mar',
    Apr: 'Abr',
    May: 'Mai',
    Jun: 'Jun',
    Jul: 'Jul',
    Aug: 'Ago',
    Sep: 'Set',
    Oct: 'Out',
    Nov: 'Nov',
    Dec: 'Dez',
  };

  const meses = Object.values(mesesMap); // Obtém os meses traduzidos

  const totalGeralPorMes = Array(12).fill(0);
  const totalGeralPorDetalhe = {};

  const rows = [];

  data.forEach((tipoDespesa) => {
    const subtotalPorMes = Array(12).fill(0);
    let subtotalPorTipo = 0;

    const detalhesRows = tipoDespesa.detalhes.map((detalhe, detalheIndex) => {
      const detalheRow = [
        detalheIndex === 0 ? tipoDespesa.tipoDespesa : '', // Mescla a coluna do tipo de despesa
        detalhe.detalheNome,
        ...Object.keys(mesesMap).map((mes, i) => {
          const valor = detalhe.valoresPorMes[mes] || 0; // Usa os nomes originais do JSON
          subtotalPorMes[i] += valor;
          totalGeralPorMes[i] += valor;
          totalGeralPorDetalhe[detalhe.detalheNome] =
            (totalGeralPorDetalhe[detalhe.detalheNome] || 0) + valor;
          return NumberFormat(valor);
        }),
        NumberFormat(detalhe.totalPorDetalhe),
      ];
      subtotalPorTipo += detalhe.totalPorDetalhe;
      return detalheRow;
    });

    rows.push(...detalhesRows);

    // Adicionar subtotal logo após os detalhes do tipo de despesa
    const subtotalRow = [
      `Subtotal`,
      '',
      ...subtotalPorMes.map((valor) => NumberFormat(valor)),
      NumberFormat(subtotalPorTipo),
    ];
    rows.push(subtotalRow);
  });

  const totalRow = [
    'Total Geral',
    '',
    ...totalGeralPorMes.map((valor) => NumberFormat(valor)),
    NumberFormat(
      Object.values(totalGeralPorDetalhe).reduce((sum, val) => sum + val, 0)
    ),
  ];

  return (
    <Document>
      <Page style={styles.page}>
        {/* Cabeçalho */}
        <View style={styles.headerContainer}>
          <Image style={styles.logo} src={logo} alt="Frota Máxima" />
          <Text style={styles.title}>Relatório de Despesas Fixas - {year}</Text>
          <Text style={styles.date}>{formattedDate}</Text>
        </View>

        <View style={styles.table}>
          {/* Cabeçalho */}
          <View style={[styles.tableRow, styles.tableHeader]}>
            <Text style={[styles.tableCellWide, { fontWeight: 'bold' }]}>
              DESPESAS
            </Text>
            <Text style={[styles.tableCellWide, { fontWeight: 'bold' }]}>
              DETALHES
            </Text>
            {meses.map((mes) => (
              <Text
                key={mes}
                style={[styles.tableCell, { fontWeight: 'bold' }]}
              >
                {mes.toUpperCase()}
              </Text>
            ))}
            <Text style={[styles.tableCell, styles.totalRow]}>TOTAL</Text>
          </View>

          {/* Linhas de dados e subtotais */}
          {rows.map((row, index) => (
            <View
              key={index}
              style={[
                styles.tableRow,
                row[0]?.includes('Subtotal') ? styles.subtotalRow : {},
              ]}
            >
              <Text style={styles.tableCellWide}>{row[0]}</Text>
              <Text style={styles.tableCellWide}>{row[1]}</Text>
              {row.slice(2, -1).map((cell, i) => (
                <Text key={i} style={styles.tableCell}>
                  {cell}
                </Text>
              ))}
              <Text style={[styles.tableCell, styles.totalRow]}>
                {row[row.length - 1]}
              </Text>
            </View>
          ))}

          {/* Total Geral */}
          <View style={[styles.tableRow, styles.totalRow]}>
            <Text style={[styles.tableCellWide, { fontWeight: 'bold' }]}>
              {totalRow[0].toUpperCase()}
            </Text>
            <Text style={[styles.tableCellWide, { fontWeight: 'bold' }]}>
              {totalRow[1]}
            </Text>
            {totalRow.slice(2).map((cell, i) => (
              <Text key={i} style={[styles.tableCell, styles.totalRow]}>
                {cell}
              </Text>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );
}

export default RelatorioPDF;
